import React from 'react';

interface ValidationIconProps {
  isValid: boolean;
  topPosition?: string; // e.g., 'top-9', 'top-10', etc.
  rightPosition?: string; // e.g., 'right-3', 'right-4', etc.
  iconSize?: string; // e.g., 'w-5 h-5', 'w-6 h-6', etc.
  iconColor?: string; // e.g., 'text-green-500', 'text-blue-500', etc.
  showCondition?: boolean; // condição adicional para mostrar o ícone
}

/**
 * Componente de ícone de validação com checkmark verde
 * TUDO EM UM LUGAR - mais simples de manter!
 */
const ValidationIcon: React.FC<ValidationIconProps> = ({
  isValid,
  topPosition = 'top-3.5',
  rightPosition = 'right-3',
  iconSize = 'w-5 h-5',
  iconColor = 'text-green-500',
  showCondition = true,
}) => {
  if (!isValid || !showCondition) {
    return null;
  }

  return (
    <div className={`absolute ${rightPosition} ${topPosition} flex items-center`}>
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        className={`${iconSize} ${iconColor}`} 
        fill="currentColor" 
        viewBox="0 0 16 16"
      >
        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
      </svg>
    </div>
  );
};

export default ValidationIcon; 